import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { AppLayout } from './components/AppLayout.js'
import { LoginPage } from './features/auth/LoginPage.js'
import { TaskDetailPanel } from './features/task/TaskDetailPanel.js'
import { ColumnPage } from './routes/ColumnPage.js'
import { HomePage } from './routes/HomePage.js'
import { ProjectBoardPage } from './routes/ProjectBoardPage.js'
import { ProfilePage } from './routes/ProfilePage.js'
import { TrashPage } from './routes/TrashPage.js'
import { ProtectedRoute } from './routes/ProtectedRoute.js'

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<AppLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/trash" element={<TrashPage />} />
            <Route path="/projects/:key" element={<ProjectBoardPage />}>
              <Route path="tasks/:id" element={<TaskDetailPanel />} />
              <Route path="trash" element={<TrashPage />} />
            </Route>
            {/* Vista de columna (fase 7): hermana del tablero, no hija, porque
                sustituye al tablero en vez de deslizarse encima de él. */}
            <Route path="/projects/:key/columns/:status" element={<ColumnPage />}>
              <Route path="tasks/:id" element={<TaskDetailPanel />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
